<p-dialog [header]="'Resumen Sistronic'" [(visible)]="showDialog" [style]="{'max-height':'90vh', 'width': '90vw'}"
  (onHide)="deleteInterval()">

  <div class="d-flex flex-wrap justify-content-between w-100">
    <div [style]="{'width': navigationService.isMobile() ? '100%' : '20%', 'position': 'relative'}">
      <div class="sticky-top px-2">
        <h3>Información</h3>
        <ul style="list-style: none;">
          <li><b>Fecha:</b> {{treatmentOrigin().fecha_formatted}}</li>
          <li><b>Maquinaria:</b> {{treatmentOrigin().maquinaria_nombre}}</li>
        </ul>
        <h3>Datos Media:</h3>
        <ul style="list-style: none;">
          <li><b>Caudal:</b> {{ averageData().averageFlow }}</li>
          <li><b>Presión:</b> {{ averageData().averagePressure }}</li>
          <li><b>Velocidad:</b> {{ averageData().averageVel }}</li>
          <li><b>Dosis:</b> {{ averageData().averageDose }}</li>
          <li><b>Rpm:</b> {{ averageData().averageRpm }}</li>

        </ul>
        <p-button *ngIf="!showGraficas" fluid="true" label="Generar Gráficas"
          (onClick)="showGraficas = true"></p-button>
      </div>
    </div>
    <div [style]="{'width': navigationService.isMobile() ? '100%' : '80%'}" class="map-detail-layout">

      <div class="map-container position-relative">
        <div class="track-detail-panel" *ngIf="selectedTrack() as track">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <p><b>Detalle del punto</b></p>
  
            <button type="button" pButton icon="pi pi-times" class="p-button-text" (click)="selectedTrack.set(null)">
            </button>
          </div>
  
          <ul class="track-detail-list">
            <li><b>Hora:</b> {{ track.time }}</li>
            <li><b>Caudal:</b> {{ track.flow }}</li>
            <li><b>Presión:</b> {{ track.pressure }}</li>
            <li><b>Velocidad:</b> {{ track.vel }}</li>
            <li><b>Dosis:</b> {{ track.dose }}</li>
            <li><b>Rpm:</b> {{ track.rpm }}</li>
            <li><b>Lat:</b> {{ track.lat }}</li>
            <li><b>Lon:</b> {{ track.lon }}</li>
          </ul>
        </div>
        <div #gmap class="resp-iframe map-active rounded" style="height: 80vh" *ngIf="showMap">
        </div>
      </div>

    </div>
  </div>

  <hr>

  <div style="margin-top: 1em;" *ngIf="showGraficas">
    <div class="d-flex flex-column flex-wrap justify-content-between w-100">
      <div class="d-flex flex-row align-items-center justify-content-between mb-3">
        <div>
          <b>Numero de gráficas </b> {{currentNumberChart() + 1}}/{{lengthDataSets()}}
        </div>
        <div class="d-flex flex-row align-items-center justify-content-end gap-2">
          <button type="button" pButton label="Siguiente" (click)="nextChart()"
            [disabled]="currentNumberChart() >= treatmentDataSets().length - 1">
          </button>
          <button type="button" pButton label="Anterior" (click)="previousChart()"
            [disabled]="currentNumberChart() <= 0">
          </button>
        </div>
      </div>

      <div class="chart-wrapper">
        <p-chart type="line" [data]="currentChart()" [options]="optionsChart" height="600px">
        </p-chart>
      </div>
    </div>
  </div>
</p-dialog>